import React from "react";
import { useTranslation } from "react-i18next";
import "../Terms/Terms.css";

const TermsConditions = () => {

  const { t } = useTranslation();

  return (
    <div className="terms-container">

      <div className="terms-header">
        <h1>{t("terms.title")}</h1>
        <h3>{t("terms.subtitle")}</h3>
        <p className="project">{t("terms.project")}</p>
        <p className="date">{t("terms.lastUpdated")}</p>
        <h2>{t("terms.pageTitle")}</h2>
      </div>

      <div className="terms-card">

        <div className="term-item">
          <h4>{t("terms.rule1Title")}</h4>
          <p>{t("terms.rule1Desc")}</p>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule2Title")}</h4>
          <p>{t("terms.rule2Desc")}</p>
          <ul>
            <li>{t("terms.breakfast")}</li>
            <li>{t("terms.lunch")}</li>
            <li>{t("terms.snacks")}</li>
            <li>{t("terms.dinner")}</li>
          </ul>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule3Title")}</h4>
          <p>{t("terms.rule3Desc")}</p>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule4Title")}</h4>
          <p>{t("terms.rule4Desc")}</p>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule5Title")}</h4>
          <p>{t("terms.rule5Desc")}</p>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule6Title")}</h4>
          <p>{t("terms.rule6Desc")}</p>
        </div>

        <div className="term-item">
          <h4>{t("terms.rule7Title")}</h4>
          <p>{t("terms.rule7Desc")}</p>
        </div>

      </div>

    </div>
  );
};

export default TermsConditions;